import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';

import Area from './Area';
import styles from './Products.module.scss';

const Products = () => {
	const products = useSelector(contractGeneratorSelectors.getProducts);

	const { selectedRooms } = useSelector(contractGeneratorSelectors.getDataToSubmit);

	const productsArray = [
		...Object.keys(products)
			.sort((a, b) => {
				return a - b;
			})
			.map(product => ({ ...products[product], id: product }))
	];

	const visibleProducts = useMemo(() => {
		return productsArray.filter(product => {
			if (selectedRooms < product.displayThresholds.minRooms || selectedRooms > product.displayThresholds.maxRooms) {
				return false;
			}

			return true;
		});
	}, [selectedRooms]);

	return (
		<>
			<div id='viato-contract-generator-product-selection' />
			<FlexBox className={styles.areas}>
				<Area products={visibleProducts} />
				<Area products={visibleProducts} isPackageArea />
			</FlexBox>
		</>
	);
};

export default Products;
